import type { ChangeEvent, ReactNode } from "react";

import classNames from "classnames";

import { RadioButton } from "@jti/core-components";
import { Tooltip } from "@jti/ui";

import styles from "./PaymentMethodOption.module.scss";

type PaymentMethodOptionProps = {
  paymentMethodCode: string;
  title: string;
  icon?: string;
  tooltip?: string;
  disabled?: boolean;
  checked?: boolean;
  children?: ReactNode;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const PaymentMethodOption = ({
  paymentMethodCode,
  icon,
  title,
  tooltip,
  disabled,
  checked = false,
  children,
  onChange,
}: PaymentMethodOptionProps) => (
  <div
    className={classNames(styles.paymentMethodItem, {
      [styles.paymentMethodItemDisabled]: disabled,
      [styles.paymentMethodItemChecked]: checked,
    })}
  >
    <div className={styles.headerRow}>
      <div className={styles.fullWidthRadio}>
        <RadioButton
          value={paymentMethodCode}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          label={
            <div className={classNames(styles.labelElement, { [styles.labelElementDisabled]: disabled })}>
              {title}
              {!!tooltip && <Tooltip content={<span>{tooltip}</span>} />}
            </div>
          }
        />
      </div>
      {!!icon && <img src={icon} alt="" className={styles.paymentMethodImg} />}
    </div>

    {children ? <div className={styles.section}>{children}</div> : null}
  </div>
);
